<form [formGroup]="form" (ngSubmit)="model ? update() : create()" appPermissionControl="P231F0001">
    <div class="form-row mt-3">
        <div class="form-field">
            <input pInputText type="text" formControlName="sResultado" class="form-control" [placeholder]="'Ingrese resultado'"
                [disabled]="model" appPermissionControl="P231K0001">
            <label>Resultado</label>
        </div>
    </div>

    <div class="form-row">
        <div class="form-field">
            <input pInputText type="text" formControlName="descripcion" class="form-control"
                [placeholder]="'Ingrese descripción'" appPermissionControl="P231K0002">
            <label>Descripción</label>
        </div>
    </div>

    <div class="checkbox-container">
        <input type="checkbox" formControlName="efectivo" id="efectivo" class="form-checkbox" appPermissionControl="P231K0003">
        <label for="efectivo" class="checkbox-label">Efectivo</label>
    </div>

    <div class="button-section">
        <button mat-flat-button class="btn-success btn-menu" (click)="model ? update() : create()"
            [disabled]="!form.valid || loading" appPermissionControl="P231B0001">
            <mat-icon>save</mat-icon>
            {{ model ? 'Actualizar' : 'Guardar' }}
        </button>
        <button *ngIf="model" mat-flat-button class="btn-search btn-menu" type="button" (click)="openCustomizables()" appPermissionControl="P231B0002">
            <mat-icon>tune</mat-icon>
            Customizables
        </button>
    </div>
</form>

<style>
    .form-row {
        display: flex;
        flex-direction: row;
        margin-bottom: 1rem;
    }

    .form-field {
        flex: 1;
        display: flex;
        flex-direction: column-reverse;
        position: relative;
    }

    .form-control {
        width: 100%;
        padding: 0.5rem;
        font-size: 1rem;
        border: 1px solid #ced4da;
        border-radius: 4px;
        background: #fff;
        transition: border-color 0.15s ease-in-out, box-shadow 0.15s ease-in-out;
    }

    .form-control:disabled {
        background: #e0e0e0 !important;
        color: #555 !important;
        opacity: 1 !important;
    }

    .form-field label {
        font-size: 0.85rem;
        color: #6c757d;
        margin-bottom: 0.25rem;
    }

    .button-section {
        display: flex;
        justify-content: flex-end;
        gap: 1rem;
        margin-top: 1.5rem;
    }

    .checkbox-container {
        display: flex;
        align-items: center;
        gap: 0.5rem;
        margin: 0;
        min-height: 40px;
        flex-direction: row;
    }

    .checkbox-label {
        font-size: 0.85rem;
        color: #6c757d;
        margin: 0;
        cursor: pointer;
        order: 2;
        line-height: 1;
    }

    .form-checkbox {
        width: 16px;
        height: 16px;
        margin: 0;
        cursor: pointer;
        order: 1;
        vertical-align: middle;
    }
</style>